var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#7367F0",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5062 26.02V28H19.5712V26.425L23.6212 22.6C24.0512 22.19 24.3412 21.84 24.4912 21.55C24.6412 21.25 24.7162 20.955 24.7162 20.665C24.7162 20.245 24.5712 19.925 24.2812 19.705C24.0012 19.475 23.5862 19.36 23.0362 19.36C22.5762 19.36 22.1612 19.45 21.7912 19.63C21.4212 19.8 21.1112 20.06 20.8612 20.41L19.0912 19.27C19.5012 18.66 20.0662 18.185 20.7862 17.845C21.5062 17.495 22.3312 17.32 23.2612 17.32C24.0412 17.32 24.7212 17.45 25.3012 17.71C25.8912 17.96 26.3462 18.32 26.6662 18.79C26.9962 19.25 27.1612 19.795 27.1612 20.425C27.1612 20.995 27.0412 21.53 26.8012 22.03C26.5612 22.53 26.0962 23.1 25.4062 23.74L22.9912 26.02H27.5062Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoIcon);
export default __webpack_public_path__ + "static/media/two-icon.aad3600a1942827e1f34e561b778e570.svg";
export { ForwardRef as ReactComponent };